// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"27ae3440","112":"699cfb73","265":"6b2112b5","404":"22d12c47","659":"41d47d73","746":"4440cfc8","793":"f32a4197","907":"2db90c77"}[chunkId] + ".chunk.css";
};